import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
  roles?: Array<'admin' | 'teacher' | 'student' | 'parent'>;
}

export function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { isAuthenticated, user, getEffectiveRole } = useAuthStore();
  const effectiveRole = getEffectiveRole();

  if (!isAuthenticated || !user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Use effective role for authorization (accounts for impersonation)
  if (roles && effectiveRole && !roles.includes(effectiveRole)) {
    return <Navigate to={`/${user.schoolSlug}/dashboard`} replace />;
  }

  return <>{children}</>;
}
